<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title13"></a>
<div class="p-c"><span><em class="i">for Trudy</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429900782_ded01.vue?fa6aaa1c